export const $imgr = (file: string, query: string = '') => {
  try {
    return `https://img-cc.sato48.com/sato48/${query}/${btoa(
      `s3://sato48-assets/${file}`,
    )}`
  } catch {
    return `https://img-cc.sato48.com/sato48/${query}/${btoa(
      `s3://sato48-assets/image-broken-custom.png`,
    )}`
  }
}
